import { BookmarkPage } from '@edwin-group/cj-graphql';

export function getTranslatedValue({ title, page }: { title: string; page: BookmarkPage }) {
  const formatTitle = title.toLowerCase();

  const section = page.sections?.filter((section) => section?.key.toLowerCase() === formatTitle)[0];

  if (section) {
    return section.value;
  }

  return title;
}
